import {
  Button,
  Card,
  Col,
  Drawer,
  Form, Icon,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Tooltip
} from 'antd'
import moment from 'moment'
import { Component, default as React } from 'react'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import { default as GetEachFormFields } from '../../../components/_utils/appFormUtils'
import {
  DefaultTablePagination,
  DisplayDate,
  formItemLayout,
  InputBox
} from '../../../components/_utils/appUtils'
import { default as Request } from '../../../request'
import { AddIssue } from '../actions'
import EditIssue from '../drawers/editIssue'
import SpecialIssueWebPageDrawer from '../drawers/specialIssueWebPageDrawer'
import { getAllMember } from '../../members/actions'
import styles from './styles.less'

const imgExt = ['jpg', 'jpeg', 'png', 'webp']

@Form.create()
class IssueJournalForm extends Component {
  issueTable = React.createRef()

  editEvents = {
    showEditDrawer: data => {
      this.setState({ issueDoc: data, editVisible: true })
    },
    hideEditDrawer: () => {
      this.setState({ issueDoc: {}, editVisible: false }, () => {
        this.issueTable.current.reload()
      })
    },
    checkCoverExt: (url) => {
      let extension = url.split('.').pop()
      if (imgExt.includes(extension && extension.toLowerCase())) {
        return true
      } else {
        return false
      }
    }
  }

  showDrawer = () => {
    this.setState({ visible: true })
  }
  onClose = () => {
    this.setState({ visible: false })
  }

  getJournalsIssueData = params => {
    return new Promise(async resolve => {
      let {
        volumeData: { journalId, volumeId }
      } = this.props
      let resp = await Request.getJournalIssue({
        journalId: journalId,
        volumeId: volumeId,
        ...params
      })
      console.log('google.com', resp)
      this.setState({ total: resp.total })
      resolve(resp)
    })
  }

  loadVolume = () => {
    this.issueTable.current.reload()
  }

  handleChange = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }

  handleSubmitIssue = e => {
    const { dispatch, form, volumeData } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let { journalId, volumeId } = volumeData
        let { coverImage, issueZip } = this.state
        valData.volumeId = volumeId
        valData.journalId = journalId
        let fd = new FormData()
        fd.append('obj', JSON.stringify(valData))
        if (coverImage && coverImage.name) {
          fd.append('coverImage', coverImage)
        }
        if (issueZip && issueZip.name) {
          fd.append('issueZip', issueZip)
        }
        let x = await dispatch(AddIssue(fd))
        let { error, message } = x
        this.setState({ fileKey: moment() })
        if (!error) {
          notification.success({
            message: message
          })
          this.loadVolume()
          form.resetFields()
        } else {
          notification.error({
            message: message,
            description: message
          })
        }
      }
    })
  }

  handleRemoveIssue = async id => {
    let x = await Request.removeJournalIssue({ _id: id })
    let { error, msg } = x
    if (!error) {
      notification.success({
        message: msg
      })
      this.loadVolume()
    } else {
      notification.error({
        message: msg,
        description: msg
      })
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      total: 0,
      coverImage: {},
      issueZip: {},
      fileKey: moment(),
      issueDoc: {},
      editVisible: false,
      visibleWebDrawer: false,
      webState: {
        visible: false,
        page: '',
        journalId: '',
        name: '',
        slugJournal: '',
        volumeId: '',
        issueId: ''
      },
      guestEditorList: []
    }
  }

  componentDidMount() {
    this.getGuestEditors()
  }

  getGuestEditors = async () => {
    let resp = await this.props.dispatch(getAllMember({ memberType: 'Guest' }))
    if (resp && resp.data) {
      this.setState({ guestEditorList: resp.data })
    }
  }

  showWebDrawer = data => {
    this.setState({
      webState: {
        visible: true,
        journalId: data.journalId,
        page: data.page,
        slugJournal: data.slugJournal,
        name: data.name,
        volumeId: data.volumeId,
        issueId: data.issueId,
        journalName: data.journalName,
        volumeName: data.volumeName,
        issueName: data.issueName
      }
    })
  }

  hideWebDrawer = () => {
    this.setState({
      webState: {
        visible: false,
        page: null,
        journalId: null,
        slugJournal: null,
        name: null,
        volumeId: null,
        issueId: null
      }
    })
  }

  render() {
    let { volumeData } = this.props
    let { editVisible, issueDoc } = this.state
    const columnsData = [
      {
        title: 'Serial No.',
        dataIndex: 'issueNumber',
        key: 'issueNumber',
        width: 60
        // render: text => <a>{text}</a>
      },
      {
        title: 'Issue Type',
        dataIndex: 'issueType',
        key: 'issueType',
        width: 110
      },
      {
        title: 'Name',
        dataIndex: 'issueName',
        key: 'issueName',
        width: 200
      },
      {
        title: 'Publish Date',
        dataIndex: 'publishDate',
        key: 'publishDate',
        width: 110,
        render: item => {
          return item ? DisplayDate(item) : ''
        }
      },
      {
        title: 'Page Range',
        dataIndex: 'pageRange',
        key: 'pageRange',
        width: 90
      },
      {
        title: 'Issue Zip',
        key: 'issueZip',
        width: 120,
        render: (val, record) => {
          return (
            <div className={'alignCenter'}>
              {val && val.path ? (
                <a href={val.path} download={val.fileName}>Download Zip</a>
              ) : null}
            </div>
          )
        }
      },
      {
        title: 'Cover Image',
        key: 'coverImage',
        width: 110,
        render: (val, record) => {
          return (
            <div className={'alignCenter'}>
              {val && val.path ? this.editEvents.checkCoverExt(val.path) ?
                  <img className={styles.img} src={val.path} /> :
                  <a src={val.path} target={'_blank'} href={val.path}>
                    <Icon type={'file-pdf'} style={{ fontSize: 20 }} />
                  </a>
                : null
              }
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'action',
        width: 230,
        render: (val, record) => {
          const webButtons = [
            { name: 'Scope & Objective', value: 'Scope & Objective' },
            { name: 'Guest Responsibilities', value: 'Guest Editor Responsibilities' },
            { name: 'Important Dates', value: 'Important Dates' },
            { name: 'Manuscript Policy', value: 'Manuscript Submission Policy' },
            { name: 'APC', value: 'Article Processing Charges' },
            { name: 'Submit Paper', value: 'Submit Paper' }
          ]

          return (
            <div className={'btnWrapGroup-grid'}>
              <Tooltip title={'Edit Details'}>
                <a className={'roundNewBtn btn-dark'}
                   onClick={() => {
                     this.editEvents.showEditDrawer(record)
                   }}><Icon type={'edit'} /> Edit
                </a>
              </Tooltip>{' '}
              <Tooltip title={'Remove'}>
                <Popconfirm
                  title={'Are sure, you want to delete issue?'}
                  onConfirm={() => {
                    this.handleRemoveIssue(record._id)
                  }}>
                  <a type='primary'
                     className={'roundNewBtn btn-dark'}>
                    <Icon type={'close'} /> Remove
                  </a>
                </Popconfirm>
              </Tooltip>
              {record.issueType === 'Special Issue' && webButtons.map((item, key) => {
                let pointNumber = key + 1
                return (
                  <a className={'roundNewBtn'}
                     key={key.value}
                     onClick={() =>
                       this.showWebDrawer({
                         page: item.value,
                         journalId: volumeData.journalId,
                         slugJournal: volumeData.slugJournal,
                         volumeId: volumeData.volumeId,
                         journalName: volumeData.journalName,
                         volumeName: volumeData.volumeName,
                         issueId: record._id,
                         issueName: record.issueName
                       })
                     }>
                    {pointNumber}. {item.name}
                  </a>
                )
              })}
            </div>
          )
        }
      }
    ]
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading,
      visible,
      onClose
    } = this.props
    const isSpecial = getFieldValue('issueType') === 'Special Issue'
    const inputSchema = {
      fields: [
        {
          label: 'Issue Type',
          key: 'issueType',
          required: true,
          type: 'select',
          options: ['Regular Issue', 'Special Issue'],
          placeholder: 'Issue type',
          customDirectives: { initialValue: 'Regular Issue' },
          onChange: val => {
            setFieldsValue({ issueType: val })
          }
        },
        {
          label: 'Issue Name',
          key: 'issueName',
          required: true,
          type: 'text',
          span: isSpecial ? 16 : 4,
          placeholder: 'Issue Name',
          onChange: e => {
            setFieldsValue({ issueName: e.target.value })
          }
        },
        {
          label: 'Issue Number',
          key: 'issueNumber',
          required: !isSpecial,
          placeholder: 'Issue Number',
          type: 'number'
        },
        {
          label: 'Page Range',
          key: 'pageRange',
          required: !isSpecial,
          placeholder: 'pageRange'
        },
        {
          label: 'Issue Zip',
          key: 'issueZip',
          span: 4,
          customField: (
            <InputBox title={`Issue Zip`}>
              <Input
                type={'file'}
                name={'issueZip'}
                id={'issueZip'}
                className={'form-control'}
                key={this.state.fileKey}
                onChange={e => {
                  this.handleChange(e)
                }}
              />
            </InputBox>
          )
        },
        {
          label: 'Cover Image',
          key: 'coverImage',
          span: 4,
          customField: (
            <InputBox title={`Cover Image`}>
              <Input
                type={'file'}
                name={'coverImage'}
                id={'coverImage'}
                className={'form-control'}
                key={this.state.fileKey}
                onChange={e => {
                  this.handleChange(e)
                }}
              />
            </InputBox>
          )
        },
        {
          label: 'Publish Date',
          key: 'publishDate',
          required: true,
          span: 4,
          placeholder: 'Publish Date',
          type: 'date'
        },
        {
          label: 'Guest Editors',
          key: 'guestEditors',
          required: isSpecial,
          hidden: !isSpecial,
          span: 8,
          customField: (
            <InputBox title={`Guest Editors`}>
              {getFieldDecorator('guestEditors', {
                initialValue: [],
                rules: [{ required: isSpecial, message: 'Please select Guest Editors' }]
              })(
                <Select
                  mode='multiple'
                  placeholder='Select Guest Editors'
                  showSearch
                  optionFilterProp='children'
                  style={{ width: '100%' }}
                >
                  {this.state.guestEditorList.map(item => (
                    <Select.Option key={item._id} value={item._id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </InputBox>
          )
        }

      ]
    }
    return (
      <Drawer
        title={`Manage Issue - ${volumeData.journalName} (Volume - ${volumeData.volumeName})`}
        width={'92%'}
        placement='right'
        closable={true}
        onClose={onClose}
        visible={visible}>
        <div style={{ padding: 10 }}>
          <Card bordered={true}>
            <Form
              onSubmit={this.handleSubmitIssue}
              hideRequiredMark
              className={'inputForm'}>
              <Row gutter={10}>
                {inputSchema.fields.map((item, key) => {
                  return (
                    <Col
                      md={item.span ? item.span : 4}
                      sm={item.span ? item.span : 4}
                      xs={24}
                      key={key}>
                      {!item.hidden && (item.customField ? (
                        item.customField
                      ) : (
                        <GetEachFormFields
                          item={item}
                          getFieldDecorator={getFieldDecorator}
                          formItemLayout={formItemLayout}
                        />
                      ))}
                    </Col>
                  )
                })}

              </Row>
              <div className={'align-right'}>
                <Button
                  type='primary'
                  htmlType='submit'
                  loading={this.props.loading}>
                  ADD
                </Button>
              </div>

            </Form>
            <h7>Total Volumes: {this.total}</h7>
            <TableComp
              columns={columnsData}
              ref={this.issueTable}
              apiRequest={this.getJournalsIssueData}
              pagination={DefaultTablePagination()}
            />
          </Card>
        </div>
        {editVisible ? (
          <EditIssue
            visible={editVisible}
            issue={issueDoc}
            onClose={this.editEvents.hideEditDrawer}
          />
        ) : null}
        {this.state.webState.visible ? (
          <SpecialIssueWebPageDrawer
            {...this.state.webState}
            onClose={() => this.hideWebDrawer()}
          />
        ) : null}
      </Drawer>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  null,
  mapDispatchToProps
)(IssueJournalForm)
